import { apiPostForm } from "./baseFetch";

export type ImportDealsResponse = {
  inserted: number;
  total_rows: number;
};

type ImportDealsOptions = {
  signal?: AbortSignal;
};

export async function importDealsFile(
  file: File,
  options: ImportDealsOptions = {}
): Promise<ImportDealsResponse> {
  const formData = new FormData();
  formData.append("file", file);
  return apiPostForm<ImportDealsResponse>("/admin/import-deals", formData, options);
}
